import axios, { AxiosResponse } from "axios";

const ENVIRONMENT_FILE_URL = "./environment";

export class EnvironmentService {
  private static settings: Record<string, string> = {};

  static async initialize(): Promise<void> {
    const response: AxiosResponse<string> = await axios.get(
      ENVIRONMENT_FILE_URL
    );
    this.settings = Object.fromEntries(
      response.data
        .split("\n")
        .map((el) => el.split("=", 2))
        .filter((el) => el.length > 1)
    );
  }

  static getVariable(variableName: string): string {
    const prefixedVariableName = "VUE_APP_" + variableName;
    const variable =
      EnvironmentService.settings[prefixedVariableName] ||
      process.env[prefixedVariableName];

    if (!variable) {
      throw new Error(
        `Environment variable '${prefixedVariableName}' not defined!`
      );
    }
    return variable;
  }
}
